<div class="container" [class.show]="showOptions">
  <img
    class="profile-picture"
    [src]="
      authService.loggedUser?.flags?.clubMember
        ? 'assets/icons/club-user.svg'
        : 'assets/icons/user.svg'
    "
    alt="profile-picture"
    (click)="showOptionsClick()"
  />
  <div
    class="arrow-separator"
    [class.show]="showOptions"
    [class.hide]="showOptions === false"
  ></div>
  <div class="user-info" [class.show]="showOptions" [class.hide]="showOptions === false">
    <div class="name">
      <p *ngIf="authService.loggedUser">
        {{ showUserName().toLowerCase() }}
      </p>
      <p *ngIf="!authService.loggedUser">Invitado</p>
    </div>
    <div class="email" *ngIf="authService.loggedUser">
      <p *ngIf="!authService.loggedUser.isBanned && authService.loggedUser.cuit !== ''">
        CUIT: {{ authService.loggedUser.cuit | slice: 0:2 }}-{{
          authService.loggedUser.cuit | slice: 2:10
        }}-{{ authService.loggedUser.cuit | slice: -1 }}
      </p>
      <p *ngIf="!authService.loggedUser.isBanned && authService.loggedUser.cuit === ''">
        CUIT: NO REGISTRADO
      </p>
    </div>
    <p
      *ngIf="
        authService.loggedUser && authService.hasConfirmedMail() && authService.loggedUser.isBanned
      "
      class="ban"
      [class.show]="showOptions"
      matTooltip="Probablemente ya hayas operado los 200 US$ de este mes."
      [matTooltipPosition]="'above'"
      matTooltipClass="tooltip"
    >
      Inhabilitado por BCRA
      <span class="icon-question"> ? </span>
    </p>
    <div
      *ngIf="authService.loggedUser"
      class="option"
      [routerLink]="['profile']"
      routerLinkActive="active"
      (click)="showOptions = false; showMenuMobile = false"
    >
      <p>Mi perfil</p>
    </div>
    <div *ngIf="authService.loggedUser" class="option" (click)="logout()">
      <p>Cerrar sesión</p>
    </div>
  </div>
</div>
